import React from 'react'
import { Link } from 'react-router-dom'

import Header from '../components/Header/Header.js'
import Footer from '../components/Footer/Footer.js'
import Button from '../components/Button/Button.js'

const WhatIsPattycake = () => (
  <div>
    <Header/>
    <div className="section-breaker">
      <div className="jumbotron">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <hr/>
              <blockquote class="blockquote">
                <p className="text-primary lead">
                  Pat-a-cake, pat-a-cake, baker's man.<br/>
                  Bake me a cake as fast as you can.<br/>
                  <br/>
                  Pat it, and prick it, and mark it with "B"<br/>
                  And put it in the oven for Baby and me!
                </p>
                <footer class="blockquote-footer">Mother Goose, <cite title="Source Title">1901.</cite><br/> 
                <small>Original by Thomas D'Urfey, Published in 1689</small></footer>
              </blockquote>
              <hr/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
)

export default WhatIsPattycake
  


// WEBPACK FOOTER //
// ./src/routes/WhatIsPattycake.js